import React from 'react';
// AQUI ESTÁ A CORREÇÃO: 'Typography' foi removido da linha abaixo
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, Box } from '@mui/material';

const LoansTable = ({ items, onUpdateStatus }) => {
  return (
    <Box sx={{ width: '100%', overflowX: 'auto' }}>
      <Paper sx={{ width: '100%', mb: 2, boxShadow: 3 }}>
        <TableContainer>
          <Table sx={{ minWidth: 750 }} aria-label="loans table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold' }}>Devedor</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Descrição</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Valor Principal</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Juros</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Total a Receber</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Vencimento</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Recebido</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(items || []).map((item) => (
                <TableRow key={item.id} hover>
                  <TableCell>{item.debtor_name}</TableCell>
                  <TableCell>{item.description}</TableCell>
                  <TableCell>{parseFloat(item.principal_amount).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</TableCell>
                  <TableCell>{item.interest_rate}%</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>{parseFloat(item.total_with_interest).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</TableCell>
                  <TableCell>{new Date(item.due_date).toLocaleDateString("pt-BR", { timeZone: 'UTC' })}</TableCell>
                  <TableCell>
                    <Checkbox
                      checked={item.paid}
                      onChange={(e) => onUpdateStatus(item.id, e.target.checked, 'loan')} // Adicionado 'loan' para consistência
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};

export default LoansTable;